import(/* webpackMode: "eager" */ "/codebuild/output/src3021673177/src/src/app/layout.tsx");
